import { Component } from '@angular/core';
import { AuthStore } from '../../store/auth.store';

@Component({
  selector: 'pxl-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  navLinks = [
    {
      title: 'Clients',
      link: ['/', 'dashboard']
    },
    {
      title: 'Reports',
      link: ['/', 'reports']
    },
    {
      title: 'health check',
      link: ['/', 'health-check']
    }
  ];
  constructor(public store: AuthStore) {}
}
